export type AuthType = 'okta' | 'default';

export type TokenInfo = {
  token: string;
  expirationUtc: string;
  isExpired?: boolean;
  isRefreshing?: boolean;
  authType: AuthType;
};

export enum SignInRoute {
  Login = 'login',
  OktaSignInCallback = 'oktaSigninCallback',
  AccessDenied = 'accessDenied',
}

export type LogoutInfo = {
  idPIdToken: string;
  message: string;
};
